import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { initialize, requestFailure, requestSuccess, submitSuccess } from './actionCreators';
const actionHandlers = {
    [initialize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isLoading: true,
            isError: false
        }),
    [requestFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isLoading: false,
            isError: true
        }),
    [requestSuccess.toString()] (state, { payload }) {
        return _object_spread_props(_object_spread({}, state), {
            isLoading: false,
            data: payload.data
        });
    },
    [submitSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            // after a submission, clear any previous init data so it's fetched again
            // if the report modal is opened - even if the page isn't refreshed -
            // this way, we can prevent report types being submitted more than once
            data: undefined
        })
};
const reducers = {
    // cast "as string" because of TS
    [reduxKey] (state = {}, action) {
        const { type, payload } = action;
        if (!actionHandlers[type]) {
            return state;
        }
        // each deviationId gets it's own mini-slice of the store
        const stateKey = payload.deviationId;
        return _object_spread_props(_object_spread({}, state), {
            [stateKey]: actionHandlers[type](state[stateKey], action)
        });
    }
};
export default reducers;
